
import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2, // Reintentos en caso de error
      refetchOnWindowFocus: false, // Evita refetch agresivo al cambiar de pestaña
      staleTime: 1000 * 60 * 5, // 5 min "fresco"
      cacheTime: 1000 * 60 * 30, // 30 min en caché
    },
    mutations: {
      retry: 1,
    },
  },
});

export default queryClient